import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaChalkboardTeacher, 
  FaGraduationCap, 
  FaMapMarkerAlt, 
  FaPhone, 
  FaEnvelope,
  FaFacebook, 
  FaTwitter, 
  FaInstagram,
  FaLinkedin,
  FaUniversity,
  FaHeart
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Internal CSS styles
  const styles = {
    footer: {
      backgroundColor: '#0A1A35',
      color: '#FFFFFF',
      padding: '3rem 0 1rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      borderTop: '4px solid #2D5BFF',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem',
    },
    footerTop: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '3rem',
      marginBottom: '3rem',
      paddingBottom: '2rem',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
    footerBrand: {
      flex: 1,
      minWidth: '300px',
    },
    brandWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    logoWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '1rem',
    },
    footerLogo: {
      fontSize: '2.5rem',
      color: '#2D5BFF',
      backgroundColor: 'rgba(45, 91, 255, 0.1)',
      padding: '0.75rem',
      borderRadius: '12px',
    },
    logoText: {
      display: 'flex',
      flexDirection: 'column',
    },
    logoTextH3: {
      margin: 0,
      fontSize: '1.8rem',
      fontWeight: '700',
      background: 'linear-gradient(90deg, #2D5BFF 0%, #5C8AFF 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    logoSubtitle: {
      fontSize: '0.9rem',
      color: '#94A3B8',
      fontWeight: '500',
    },
    brandTagline: {
      fontSize: '1rem',
      lineHeight: '1.6',
      color: '#CBD5E1',
      margin: 0,
      maxWidth: '300px',
    },
    footerLinks: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '2rem',
    },
    linksColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    linksTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#FFFFFF',
      margin: 0,
      position: 'relative',
      paddingBottom: '0.5rem',
    },
    linksTitleAfter: {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '40px',
      height: '3px',
      background: 'linear-gradient(90deg, #2D5BFF 0%, #5C8AFF 100%)',
      borderRadius: '2px',
    },
    linksList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
    },
    footerLink: {
      color: '#CBD5E1',
      textDecoration: 'none',
      fontSize: '1rem',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.25rem 0',
    },
    footerLinkHover: {
      color: '#2D5BFF',
      transform: 'translateX(5px)',
    },
    footerContact: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    contactTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#FFFFFF',
      margin: 0,
      position: 'relative',
      paddingBottom: '0.5rem',
    },
    contactTitleAfter: {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '40px',
      height: '3px',
      background: 'linear-gradient(90deg, #2D5BFF 0%, #5C8AFF 100%)',
      borderRadius: '2px',
    },
    contactInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    contactItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1rem',
    },
    contactIcon: {
      color: '#2D5BFF',
      fontSize: '1.2rem',
      marginTop: '0.25rem',
      flexShrink: 0,
    },
    contactText: {
      fontSize: '0.95rem',
      lineHeight: '1.5',
      color: '#CBD5E1',
    },
    contactLink: {
      color: '#CBD5E1',
      textDecoration: 'none',
      fontSize: '0.95rem',
      lineHeight: '1.5',
      transition: 'color 0.3s ease',
    },
    contactLinkHover: {
      color: '#2D5BFF',
    },
    footerMiddle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '2rem 0',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      marginBottom: '2rem',
      flexWrap: 'wrap',
      gap: '2rem',
    },
    socialSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    socialTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#FFFFFF',
      margin: 0,
    },
    socialLinks: {
      display: 'flex',
      gap: '1rem',
    },
    socialLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      color: '#CBD5E1',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
    },
    socialLinkHover: {
      backgroundColor: '#2D5BFF',
      color: '#FFFFFF',
      transform: 'translateY(-3px)',
    },
    socialIcon: {
      fontSize: '1.2rem',
    },
    universityBadge: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      padding: '1rem 1.5rem',
      backgroundColor: 'rgba(45, 91, 255, 0.1)',
      borderRadius: '12px',
      border: '1px solid rgba(45, 91, 255, 0.2)',
    },
    universityIcon: {
      fontSize: '2rem',
      color: '#2D5BFF',
    },
    universityText: {
      display: 'flex',
      flexDirection: 'column',
    },
    universityName: {
      fontSize: '0.9rem',
      fontWeight: '600',
      color: '#FFFFFF',
    },
    universityProject: {
      fontSize: '0.8rem',
      color: '#94A3B8',
    },
    footerBottom: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: '1rem',
      flexWrap: 'wrap',
      gap: '2rem',
    },
    copyright: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    copyrightText: {
      margin: 0,
      fontSize: '0.9rem',
      color: '#94A3B8',
    },
    madeWith: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      margin: 0,
      fontSize: '0.9rem',
      color: '#94A3B8',
    },
    heartIcon: {
      color: '#FF4757',
      fontSize: '0.8rem',
      animation: 'heartbeat 1.5s ease-in-out infinite',
    },
    developerInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      textAlign: 'right',
    },
    developerText: {
      margin: 0,
      fontSize: '0.9rem',
      color: '#94A3B8',
    },
    leaderName: {
      color: '#2D5BFF',
      fontWeight: '600',
    },
    courseInfo: {
      margin: 0,
      fontSize: '0.85rem',
      color: '#64748B',
    },
    // Keyframes for animation
    keyframes: {
      heartbeat: {
        '0%': { transform: 'scale(1)' },
        '14%': { transform: 'scale(1.3)' },
        '28%': { transform: 'scale(1)' },
        '42%': { transform: 'scale(1.3)' },
        '70%': { transform: 'scale(1)' },
      }
    }
  };

  // Inline hover styles for interactive elements
  const linkHoverStyle = {
    color: '#2D5BFF',
    transform: 'translateX(5px)',
  };

  const socialLinkHoverStyle = {
    backgroundColor: '#2D5BFF',
    color: '#FFFFFF',
    transform: 'translateY(-3px)',
  };

  const contactLinkHoverStyle = {
    color: '#2D5BFF',
  };

  return (
    <footer style={styles.footer}>
      <style>
        {`
          @keyframes heartbeat {
            0% { transform: scale(1); }
            14% { transform: scale(1.3); }
            28% { transform: scale(1); }
            42% { transform: scale(1.3); }
            70% { transform: scale(1); }
          }
          
          .footer-link {
            transition: all 0.3s ease;
          }
          
          .footer-link:hover {
            color: #2D5BFF;
            transform: translateX(5px);
          }
          
          .social-link {
            transition: all 0.3s ease;
          }
          
          .social-link:hover {
            background-color: #2D5BFF;
            color: #FFFFFF;
            transform: translateY(-3px);
          }
          
          .contact-link {
            transition: color 0.3s ease;
          }
          
          .contact-link:hover {
            color: #2D5BFF;
          }
          
          @media (max-width: 768px) {
            .footer-top {
              grid-template-columns: 1fr;
              gap: 2rem;
            }
            
            .footer-middle {
              flex-direction: column;
              align-items: flex-start;
            }
            
            .footer-bottom {
              flex-direction: column;
              align-items: flex-start;
              text-align: left;
            }
            
            .developer-info {
              text-align: left;
            }
          }
        `}
      </style>
      
      <div style={styles.container}>
        {/* Top Section */}
        <div style={styles.footerTop}>
          <div style={styles.footerBrand}>
            <div style={styles.brandWrapper}>
              <div style={styles.logoWrapper}>
                <FaChalkboardTeacher style={styles.footerLogo} />
                <div style={styles.logoText}>
                  <h3 style={styles.logoTextH3}>Tutor Connect</h3>
                  <span style={styles.logoSubtitle}>Cameroon</span>
                </div>
              </div>
              <p style={styles.brandTagline}>
                Bridging the gap between students and tutors across Cameroon
              </p>
            </div>
          </div>

          <div style={styles.footerLinks}>
            <div style={styles.linksColumn}>
              <h4 style={styles.linksTitle}>
                Quick Links
                <span style={styles.linksTitleAfter}></span>
              </h4>
              <ul style={styles.linksList}>
                <li><Link to="/" className="footer-link" style={styles.footerLink}>Home</Link></li>
                <li><Link to="/search" className="footer-link" style={styles.footerLink}>Find Tutors</Link></li>
                <li><Link to="/register" className="footer-link" style={styles.footerLink}>Register</Link></li>
                <li><Link to="/login" className="footer-link" style={styles.footerLink}>Login</Link></li>
              </ul>
            </div>

            <div style={styles.linksColumn}>
              <h4 style={styles.linksTitle}>
                Information
                <span style={styles.linksTitleAfter}></span>
              </h4>
              <ul style={styles.linksList}>
                <li><Link to="/about" className="footer-link" style={styles.footerLink}>About Us</Link></li>
                <li><Link to="/contact" className="footer-link" style={styles.footerLink}>Contact</Link></li>
                <li><Link to="/terms" className="footer-link" style={styles.footerLink}>Terms of Service</Link></li>
                <li><Link to="/privacy" className="footer-link" style={styles.footerLink}>Privacy Policy</Link></li>
              </ul>
            </div>
          </div>

          <div style={styles.footerContact}>
            <h4 style={styles.contactTitle}>
              Get in Touch
              <span style={styles.contactTitleAfter}></span>
            </h4>
            <div style={styles.contactInfo}>
              <div style={styles.contactItem}>
                <FaMapMarkerAlt style={styles.contactIcon} />
                <span style={styles.contactText}>University of Buea, Cameroon</span>
              </div>
              <div style={styles.contactItem}>
                <FaEnvelope style={styles.contactIcon} />
                <a 
                  href="mailto:contact@tutorconnectcm.com" 
                  className="contact-link" 
                  style={styles.contactLink}
                >
                  contact@tutorconnectcm.com
                </a>
              </div>
              <div style={styles.contactItem}>
                <FaPhone style={styles.contactIcon} />
                <a 
                  href="tel:+237671657357" 
                  className="contact-link" 
                  style={styles.contactLink}
                >
                  +237 671 657 357
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Middle Section - Social */}
        <div style={styles.footerMiddle}>
          <div style={styles.socialSection}>
            <h4 style={styles.socialTitle}>Follow Us</h4>
            <div style={styles.socialLinks}>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="Facebook"
                style={styles.socialLink}
              >
                <FaFacebook style={styles.socialIcon} />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="Twitter"
                style={styles.socialLink}
              >
                <FaTwitter style={styles.socialIcon} />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="Instagram"
                style={styles.socialLink}
              >
                <FaInstagram style={styles.socialIcon} />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="LinkedIn"
                style={styles.socialLink}
              >
                <FaLinkedin style={styles.socialIcon} />
              </a>
            </div>
          </div>

          <div style={styles.universityBadge}>
            <FaUniversity style={styles.universityIcon} />
            <div style={styles.universityText}>
              <span style={styles.universityName}>University of Buea</span>
              <span style={styles.universityProject}>Cloud Computing Project</span>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={styles.footerBottom}>
          <div style={styles.copyright}>
            <p style={styles.copyrightText}>
              © {currentYear} Tutor Connect Cameroon. All rights reserved.
            </p>
            <p style={styles.madeWith}>
              Made with <FaHeart style={styles.heartIcon} /> by Group 9
            </p>
          </div>
          
          <div style={styles.developerInfo}>
            <p style={styles.developerText}>
              Team Leader: <span style={styles.leaderName}>BESONG WISDOM</span>
            </p>
            <p style={styles.courseInfo}>
              CEC315 - Introduction to Cloud Computing
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;